import { api } from './api'
import type { OIDCApi, OIDCApiResponse, CreateApiRequest, UpdateApiRequest } from '@/types/api'

export const apisApi = {
  getApis: async (nextToken?: string): Promise<OIDCApiResponse> => {
    console.log('🔍 Fetching OIDC APIs', { nextToken })
    const params = nextToken ? { next_token: nextToken } : {}
    const response = await api.get<OIDCApiResponse>('/oidc/apis', { params })
    console.log('✅ Fetched OIDC APIs:', response.data)
    return response.data
  },

  getApi: async (apiId: string): Promise<OIDCApi> => {
    console.log('🔍 Fetching OIDC API:', apiId)
    const response = await api.get<OIDCApi>(`/oidc/apis/${apiId}`)
    console.log('✅ Fetched OIDC API:', response.data)
    return response.data
  },

  createApi: async (request: CreateApiRequest): Promise<OIDCApi> => {
    console.log('📝 Creating OIDC API:', request)
    const response = await api.post<OIDCApi>('/oidc/apis', request)
    console.log('✅ Created OIDC API:', response.data)
    return response.data
  },

  updateApi: async (request: UpdateApiRequest): Promise<OIDCApi> => {
    console.log('📝 Updating OIDC API:', request)
    const response = await api.put<OIDCApi>(`/oidc/apis/${request.apiId}`, request)
    console.log('✅ Updated OIDC API:', response.data)
    return response.data
  },

  deleteApi: async (apiId: string): Promise<void> => {
    console.log('🗑️ Deleting OIDC API:', apiId)
    await api.delete(`/oidc/apis/${apiId}`)
    console.log('✅ Deleted OIDC API')
  },

  addClientToApi: async (apiId: string, clientId: string): Promise<OIDCApi> => {
    console.log(`➕ Adding client ${clientId} to API ${apiId}`)
    const response = await api.post<OIDCApi>(`/oidc/apis/${apiId}/clients/${clientId}`)
    console.log('✅ Client added to API:', response.data)
    return response.data
  },

  removeClientFromApi: async (apiId: string, clientId: string): Promise<OIDCApi> => {
    console.log(`➖ Removing client ${clientId} from API ${apiId}`)
    const response = await api.delete<OIDCApi>(`/oidc/apis/${apiId}/clients/${clientId}`)
    console.log('✅ Client removed from API:', response.data)
    return response.data
  }
}